// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"sites_tabHeader_38mhSeo","tabTitle":"sites_tabTitle_beE2h13","site":"sites_site_2pEQi9N","actions":"sites_actions_xoiilNn","label":"sites_label_1OQEvVC"};